import React,{Fragment,useState} from 'react';
import logo from "../images/Fondo.jpg"
import work from "../images/under.jpg"

import {Grid, makeStyles, Container} from '@material-ui/core';

import Header from './Header';
import Track from './Track';
import Footer from './Footer';
import Listado from './ListaResultado';
import Flujo from './Flujo';
import Enviar from './EnviarCorreo';


const estilos = makeStyles(theme=>({
    root:{
        display:"flex"
    },
    paper: {
       
        textAlign: 'center',
        
      },

}))

const Tracking = () => {

    const classes = estilos();

    const [find,setFind] = useState(false);

    const [status,setStatus] = useState({
        CargaRecepcionada: "undef",
        CargaEnRuta: "undef",
        CargaEnDestino: "undef",
        CargaEntregada: "undef"
    });

    return ( 

            <div aling="center">

                <center>

                <h1>Líneas Áereas Suramericanas Tracking</h1>

                <img src={work} alt="Muy pronto seguiras a tu mercancia en linea"></img>
                </center>

            </div>
        

        
        // <Container maxWidth="lg">

        //     <div className={classes.root}>
        //         <Grid container spacing={2} justify="center">

        //             <Grid item xs={12}>
        //                 <Header />
        //             </Grid>

        //             <Grid  item xs={12}>
        //                 <img src={logo} alt="Imagen emblematica de LAS" width="1200"/>
        //             </Grid>

        //             <Grid container justify="center" item xs={12}>
        //                 <Grid item>
        //                     <Track 
        //                         setFind={setFind}
        //                     />
        //                 </Grid>
        //             </Grid>
                    
        //             {find
        //             ? <Fragment> 
        //                 <Grid item xs={12}>
        //                     <Listado
        //                         setStatus={setStatus}
        //                     />
        //                 </Grid>

        //                 <Grid item xs={12}>
        //                     <Flujo
        //                         status={status}
        //                     />               
        //                 </Grid>

        //                 {/* <Grid item xs={12}>
        //                     <Enviar />
        //                 </Grid> */}
        //             </Fragment>
        //             : null
        //             }

                   

        //             <Grid item xs={12}>
        //                 <Footer />
        //             </Grid>

        //         </Grid>
        //     </div>
        // </Container>

    );
}
 
export default Tracking;